export const fieldGroupTableCustomSettings = {
  // Statusi prijave kvara u Prijavi kvara
  "6E00EBA9-41D8-44E2-92C4-D433CEEE6942": {
    actionButtons: customConfigParameters => {
      return undefined
    },
  },
}
